/**************************************************
 * Nombre:       Formulario_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {MoneyOutlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Deposito = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor en USD'} dato={'valor'} {...props}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{textAlign: 'center'}}>Creado el Deposito se te redirigira a Payphone, nuestra
                        pasarela de pago</Typography>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Deposito